import type { ReactNode, SVGProps } from "react";

export function SimulateInboundIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="0 0 18 16"
			width="18"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.99342 8.86029H1.46711C1.24377 8.86029 1.02957 8.77353 0.871647 8.61909C0.713722 8.46465 0.625 8.25518 0.625 8.03676V1.44853C0.625 1.23012 0.713722 1.02065 0.871647 0.866206C1.02957 0.711765 1.24377 0.625 1.46711 0.625H11.5724C11.7957 0.625 12.0099 0.711765 12.1678 0.866206C12.3258 1.02065 12.4145 1.23012 12.4145 1.44853V3.91912"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M8.20418 12.1545H4.83576C4.61242 12.1545 4.39822 12.0677 4.2403 11.9133C4.08237 11.7588 3.99365 11.5494 3.99365 11.331V4.74272C3.99365 4.52431 4.08237 4.31484 4.2403 4.1604C4.39822 4.00595 4.61242 3.91919 4.83576 3.91919H14.941C15.1644 3.91919 15.3786 4.00595 15.5365 4.1604C15.6944 4.31484 15.7831 4.52431 15.7831 4.74272V6.80154"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M11.4997 7.55681C11.4143 7.28313 11.2575 7.03593 11.0447 6.83955C10.8319 6.64317 10.5705 6.50439 10.2862 6.43688C10.0018 6.36937 9.70445 6.37546 9.42326 6.45455C9.14208 6.53364 8.88681 6.683 8.68261 6.88792C8.47841 7.09284 8.33232 7.34625 8.25873 7.62318C8.18514 7.90011 8.18659 8.19102 8.26294 8.46723C8.33929 8.74345 8.4879 8.99545 8.69414 9.19841C8.90037 9.40137 9.15712 9.54829 9.43908 9.62469"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M11.5723 12.1543H16.6249"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M14.0986 9.68384L11.5723 12.1544L14.0986 14.625"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
